<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2021-06-18 11:11:03
 * @Description: 
--> 
<template>
  <div class="background">
    <div class="main-body">
      <h1 style="padding-bottom: 12px">登陆</h1>
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="手机号" prop="mobile">
          <Input v-model="formItem.mobile" placeholder="输入手机号" />
        </FormItem>
        <FormItem label="密码" prop="password">
          <Input
            type="password"
            @on-enter="handleSubmit('formItem')"
            v-model="formItem.password"
            placeholder="输入密码"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">登陆</Button>
        </FormItem>
      </Form>
      <router-link to="/signup">
        <a>没有账号？点击注册</a>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { userInfo } from "@/api/auth";

export default {
  name: "login",
  components: {},
  data() {
    return {
      formItem: {
        mobile: null,
        password: null,
      },
      ruleValidate: {
        mobile: [{ required: true, message: "请填写名字", trigger: "blur" }],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      login: "auth/loginAction",
      getMyInfo: "auth/getMyInfoAction"
    }),
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            await this.login(this.formItem);
            if (this.user.initial) {
              this.$router.push("/changePassword");
            } else {
              this.$Message.success("登陆成功!");
              await this.getMyInfo();
              this.$router.push("/home/task");
            }
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.background
  width 100%
  height 100vh
  background-color #425384
  overflow hidden
  display flex
  justify-content center
  align-items center

.main-body
  width 400px
  height 400px
  background-color white
  border-radius 6px
  padding 12px
</style>
